<template>
  <el-dialog
    :visible.sync="visible"
    custom-class="new-flow-chart-dialog"
    :fullscreen="fullscreen"
    :width="width"
    show-close
    destroy-on-close
    append-to-body
    close-on-press-escape
  >
    <template #title>
      <div class="new-flow-chart-dialog-title">
        <i class="el-dialog__close el-icon-back" @click="visible = false" />
        <span class="el-dialog__title">{{ t('eip.common.flowChart') }}</span>
      </div>
    </template>

    <Chart v-if="visible" :params="params" @error="onError" />
  </el-dialog>
</template>

<script>
  import Chart from './Chart.vue'
  import { t } from '@/init'

  export default {
    name: 'FlowChart',
    components: { Chart },
    props: {
      fullscreen: {
        type: Boolean,
        default: true,
      },
      width: {
        type: String,
      },
    },
    data() {
      return {
        visible: false,
        params: null,
      }
    },
    methods: {
      t,
      async handleOpen(params) {
        this.visible = true

        this.params = params
      },
      onError() {
        this.visible = false
      },
    },
  }
</script>

<style lang="scss">
  .el-dialog.new-flow-chart-dialog {
    .el-dialog__header {
      height: 24px;
      overflow: hidden;
      .el-dialog__close {
        font-size: 20px;

        &:hover {
          color: #0560fd;
          cursor: pointer;
        }

        &.el-icon-back {
          color: #0560fd;
        }
      }
      .el-dialog__title {
        padding-left: 10px;
      }

      .el-dialog__headerbtn.button-back {
        left: 0px;
      }
    }

    .el-dialog__body {
      height: calc(100% - 76px);
      padding: 10px 20px;
    }
  }
</style>
